import { createSelector } from 'reselect'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import type { OfferPageRoomsTransitionState } from 'contexts/OfferPage/offerPageRoomActions'

export const getOfferPageRoomsTransitionState = createSelector(
  (state: OfferPageState) => state.offer,
  (state: OfferPageState) => state.rooms,
  (state: OfferPageState) => state.duration,
  (state: OfferPageState) => state.multiRoomMode,
  (state: OfferPageState) => state.flashPackageSelectionActive,
  (state: OfferPageState) => state.flashSameRoomSelection,
  (offer, rooms, duration, multiRoomMode, flashPackageSelectionActive, flashSameRoomSelection): OfferPageRoomsTransitionState => ({ offer, rooms, duration, multiRoomMode, flashPackageSelectionActive, flashSameRoomSelection }),
)
